import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { assessmentExchangeApi } from '../../services/assessmentExchangeApi';
import { assessmentExchangeKeys } from './useGetAssessmentExchange';

export function useDeleteAssessmentExchange() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => assessmentExchangeApi.deleteAssessmentExchange(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted assessment exchange');
        queryClient.invalidateQueries({ queryKey: assessmentExchangeKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete assessment exchange'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete assessment exchange'}`);
    },
  });
}
